import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled from 'styled-components';
import { g as getRem } from './styled-utils-3f8463ca.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-gap: ", ";\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GridContainer = styled.div(_templateObject(), function (_ref) {
  var cols = _ref.cols;
  return cols && "repeat(".concat(cols, ", 1fr)");
}, function (_ref2) {
  var gap = _ref2.gap,
      theme = _ref2.theme;
  return gap && getRem(theme.space[gap]);
});

var Grid = function Grid(_ref) {
  var cols = _ref.cols,
      gap = _ref.gap,
      children = _ref.children,
      className = _ref.className;
  return React.createElement(GridContainer, {
    cols: cols,
    gap: gap,
    className: className
  }, children);
};

Grid.defaultProps = {
  className: null,
  cols: 6,
  gap: 3
};
Grid.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Grid",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "cols": {
      "defaultValue": {
        "value": "6",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "The number of columns in the Grid"
    },
    "gap": {
      "defaultValue": {
        "value": "3",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "The the index of the value in the space array to use as the size of the gap\r\nbetween columns and rows"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "The children of the Grid"
    }
  }
};
export default Grid;
export { Grid };